<template>
    <div id="modal-container" :class="{ out: closing }" class="one">
        <div class="modal-background">
            <div class="modal">
                <svg v-on:click="out" class="close" version="1.1" id="Cross" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                             viewBox="0 0 20 20" enable-background="new 0 0 20 20" xml:space="preserve">
                            <path fill="#FFFFFF" d="M14.348,14.849c-0.469,0.469-1.229,0.469-1.697,0L10,11.819l-2.651,3.029c-0.469,0.469-1.229,0.469-1.697,0
                                c-0.469-0.469-0.469-1.229,0-1.697l2.758-3.15L5.651,6.849c-0.469-0.469-0.469-1.228,0-1.697s1.228-0.469,1.697,0L10,8.183
                                l2.651-3.031c0.469-0.469,1.228-0.469,1.697,0s0.469,1.229,0,1.697l-2.758,3.152l2.758,3.15
                                C14.817,13.62,14.817,14.38,14.348,14.849z"/>
                        </svg>
                <div class="modal-content">
                    <slot>This is empty</slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
    	props: [
    	    "close"
        ],
		data: function () {
			return {
				closing: false
			}
		},
		mounted: function () {
			// debugger;
			window.document.body.classList.add("features-search-modal-open");
		},
		destroyed: function () {
			window.document.body.classList.remove("features-search-modal-open");
		},
		methods: {
			out: function () {
				this.closing = true;
				setTimeout(() => {
					this.close();
					this.closing = false;
				},800);
			}
		}
    }
</script>

<style src="./fullscreen-modal.css"></style>


// WEBPACK FOOTER //
// fullscreen-modal.vue?23bed59b